import React from 'react';
import { SuperTeacherPanelContainer } from './SuperTeacherPanel.style';
import { Button } from 'react-inv-forms';
import { useTranslation } from 'react-i18next';
import { UserOutlined } from '@ant-design/icons';
export interface SuperTeacherPanelProps {
  /** informacja czy supernauczyciel jest zalogowany w imieniu innego nauczyciela */
  logged: boolean;
  /** callback wykonywany po kliknięciu na przycisk "Zaloguj jako" */
  onOpen: () => void;
  /** callback wykonywany po kliknięciu na przycisk "Wyloguj" */
  onLogout: () => void;
}

/**
 * Komponent panelu supernauczyciela
 *  jeśli supernauczyciel nie jest jeszcze zalogowany w imieniu innego nauczyciela - wyświetlony jest przycisk "Zaloguj jako"
 *  jeśli jest - wyświetlony jest przycisk "Powrót do głównego konta"
 *
 */
export const SuperTeacherPanel: React.FunctionComponent<SuperTeacherPanelProps> = (
  props: SuperTeacherPanelProps,
): React.ReactElement => {
  const { t } = useTranslation();
  const { onOpen, onLogout, logged } = props;
  return (
    <SuperTeacherPanelContainer>
      {logged ? (
        <Button outlined={true} onClick={onLogout} data-cy='btnLogoutFrom'>
          {t('SUPERTEACHER_PANEL_LOGOUT_FROM')}
        </Button>
      ) : (
        <Button outlined onClick={onOpen} data-cy='btnLoginAs'>
          <UserOutlined />
          {t('SUPERTEACHER_PANEL_LOGIN_AS')}
        </Button>
      )}
    </SuperTeacherPanelContainer>
  );
};
